import { render } from "./MeetingSummary.vue?vue&type=template&id=bdc71014&scoped=true"
import script from "./MeetingSummary.vue?vue&type=script&lang=js"
export * from "./MeetingSummary.vue?vue&type=script&lang=js"

import "./MeetingSummary.vue?vue&type=style&index=0&id=bdc71014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc71014"]])

export default __exports__